import { Campaign, CategoryTab, Showstopper, UpcomingCampaign } from '@shared/types/mylounge';
import { CampaignFilterTags, CategoryTabIds } from '@client/components/mylounge/banner/constants';

export interface State {
    openCampaigns: Campaign[];
    tabs: CategoryTab[];
    showstoppers: Showstopper[];
    upcomingCampaigns: UpcomingCampaign[];
    loading: boolean;
    error?: string;
    imagesLoaded: boolean;
    categoryTabId: CategoryTabIds;
    filterTag: CampaignFilterTags;
}

export const initialState: State = {
    openCampaigns: [],
    tabs: [],
    showstoppers: [],
    upcomingCampaigns: [],
    loading: false,
    error: undefined,
    imagesLoaded: false,
    categoryTabId: CategoryTabIds.ALL,
    filterTag: CampaignFilterTags.ALL,
};
